import { render, staticRenderFns } from "./TipsPop.vue?vue&type=template&id=3958737f&scoped=true"
import script from "./TipsPop.vue?vue&type=script&lang=ts"
export * from "./TipsPop.vue?vue&type=script&lang=ts"
import style0 from "./TipsPop.vue?vue&type=style&index=0&id=3958737f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3958737f",
  null
  
)

export default component.exports